import MotivoAbandono from '../../../models/camiones/motivos_abandono'

export function requestMotivosAbandono () {
  return dispatch => {
    dispatch({ type: 'REQUEST_MOTIVOS_ABANDONO' })
    return MotivoAbandono.getAll()
      .then(motivosAbandono => {
        dispatch({
          type: 'RECEIVE_MOTIVOS_ABANDONO',
          motivosAbandono })
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_MOTIVOS_ABANDONO',
        motivosAbandono: []
      }))
  }
};

export function setMotivoAbandono (motivoAbandono) {
  return dispatch => {
    dispatch({
      type: 'SET_MOTIVO_ABANDONO',
      motivoAbandono
    })
  }
}
